export default class BaseFilter {
    constructor() {
        this.body = document.querySelector("body");
        this.apiUrl = this.getGlobalApiUrl();
    }

    disableFilter() {
        this.body.classList.add("is-filter-disabled");
    }

    enableFilter() {
        this.body.classList.remove("is-filter-disabled");
    }

    isFilterInProgress() {
        return this.body.classList.contains("is-filter-disabled");
    }

    getGlobalApiUrl() {
        return this.body.getAttribute("data-api-url");
    }

    getApiUrlFromElement(class_name) {
        if (document.querySelector(class_name) !== null) {
            return document.querySelector(class_name).getAttribute("data-url");
        }

        return "";
    }

    updateUrls(stateData, url) {
        history.pushState(stateData, document.title, url);
    }

    loadAjax(url, params, stateHistory = true) {
        let xhr = new XMLHttpRequest();

        xhr.onload = () => {
            // Process our return data
            if (xhr.status >= 200 && xhr.status < 300) {
                // What do when the request is successful
                // console.log("success!", xhr);

                this.afterFilterAjax(xhr.response, stateHistory);
            } else {
                this.enableFilter();
                // What do when the request fails
                // console.log("The request failed!");
                //console.log('The request failed!');
            }
        };

        xhr.open("GET", this.apiUrl + "/" + url + params);
        xhr.send();
    }
}
